var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor__container"},[_c('section',{staticClass:"editor__tabs"},[_c('b-tabs',{on:{"input":_vm.changeTab}},_vm._l((_vm.value),function(tab){return _c('b-tab',{key:tab.title,attrs:{"title":tab.title}})}),1)],1),_vm._v(" "),_c('section',{staticClass:"tabcontent-border",attrs:{"id":"editor"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70123498","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CodeEditor.vue
// module id = null
// module chunks = 